$(function () {	
	//open pop up
	$('.the360link').on('click', function(e){
		e.preventDefault();
		$('#div360mask').fadeIn(300);    
		$('#div360dialog').show().attr('aria-hidden', 'false');
		$('#hypCloseLink').focus();
	});
	$('.the360link').on('keypress', function(e){
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	function closePopup(){
		$('.the360link ').focus();
		$('#div360mask, .div360window').fadeOut(300);
		$('#div360dialog').hide().attr('aria-hidden', 'true');
	}
	//if close button is activated
	$('#hypCloseLink').on('click', function(e){
		e.preventDefault();
		closePopup();
	});    
	$('#hypCloseLink').on('keypress', function(e){
		if(e.which == 13){
 			$(this).click();
	 	}
	}); 
   	//if mask is clicked
    	$('#div360mask').click(function () {
		closePopup();
   	});  
   	//if escape is pressed
   	$(document).keydown(function(e) {
   		if (e.keyCode === 27) {
   			closePopup();
   		}
   	});
});